/**
 * Утилиты для работы с музыкальными данными
 */

// Константы для музыкальных расчетов
export const MUSIC_CONSTANTS = {
    BEATS_PER_MEASURE: 4,
    DOTTED_NOTE_MULTIPLIER: 1.5,
    SECONDS_PER_MINUTE: 60,
    DEFAULT_TEMPO: 120,
    MILLISECONDS_PER_SECOND: 1000
};

/**
 * Рассчитывает длительность ноты в долях такта
 * @param {number} durationValue - значение длительности (1, 2, 4, 8, и т.д.)
 * @param {boolean} isDotted - является ли нота пунктирной
 * @returns {number} длительность в долях такта
 */
export function calculateNoteDuration(durationValue, isDotted = false) {
    const stepDuration = MUSIC_CONSTANTS.BEATS_PER_MEASURE / durationValue;
    return isDotted ? stepDuration * MUSIC_CONSTANTS.DOTTED_NOTE_MULTIPLIER : stepDuration;
}

/**
 * Конвертирует время в секундах на основе темпа
 * @param {number} beats - количество долей
 * @param {number} tempo - темп в BPM
 * @returns {number} время в секундах
 */
export function beatsToSeconds(beats, tempo = MUSIC_CONSTANTS.DEFAULT_TEMPO) {
    return beats * (MUSIC_CONSTANTS.SECONDS_PER_MINUTE / tempo);
}

/**
 * Конвертирует время в миллисекундах на основе темпа
 * @param {number} beats - количество долей
 * @param {number} tempo - темп в BPM
 * @returns {number} время в миллисекундах
 */
export function beatsToMilliseconds(beats, tempo = MUSIC_CONSTANTS.DEFAULT_TEMPO) {
    return beatsToSeconds(beats, tempo) * MUSIC_CONSTANTS.MILLISECONDS_PER_SECOND;
}

